import { render, staticRenderFns } from "./Form.General.vue?vue&type=template&id=2ddb4a8d"
import script from "./Form.General.vue?vue&type=script&lang=js"
export * from "./Form.General.vue?vue&type=script&lang=js"
import style0 from "./Form.General.vue?vue&type=style&index=0&id=2ddb4a8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports